// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"382":"31d6cfe0","718":"041a3d33"}[chunkId] + ".chunk.css";
};